<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="none">
    <path
      fill="currentColor"
      d="M0 19C0 8.507 8.507 0 19 0s19 8.507 19 19-8.507 19-19 19S0 29.493 0 19Z"
    />
    <path
      fill="#fff"
      d="M25.95 13.412a1.3 1.3 0 0 1 1.985 1.674l-.085.102-9.727 10.4a1.3 1.3 0 0 1-1.805.091l-.094-.091-5.873-6.28a1.3 1.3 0 0 1 1.803-1.87l.095.093 4.924 5.266 8.778-9.385Z"
    />
  </svg>
</template>
